import { useState } from "react";
import { chatRooms } from "@/mocks/home";

const roomSamples: Record<string, string[]> = {
  深夜书房: ["最近在重读《小王子》，成年后再看完全是另一种感受。", "有人一起看周末的那部文艺片吗？", "加班到现在，想找个人随便说说话。"],
  周末露营团: ["这周天气不错，有没有人去近郊营地？", "求推荐一款轻便的折叠椅，预算三百左右。", "上次露营的照片整理好了，晚上发群里。"],
  烘焙厨房: ["第一次做欧包，气孔还行吗？", "谁有靠谱的可颂配方，想复刻一次。", "周末组个烘焙局？我出烤箱你出面粉。"],
  职场茶话会: ["转岗纠结中，大家会为了兴趣降薪吗？", "分享一个挺有用的时间管理方法。", "有没有人同样在准备考证，一起打卡。"],
  观影同好: ["这周片单想加一部老片，有推荐吗？", "刚看完新上映的，结尾那段长镜头太喜欢了。", "周五晚上约一场线下观影？"],
  健身打卡: ["今天完成了五公里，打卡记录一下。", "求一个适合久坐族的拉伸动作。", "周末约晨跑，公园东门六点半。"],
};

const moodClasses: Record<string, string> = {
  安静: "bg-secondary-100 text-secondary-800",
  热闹: "bg-primary-100 text-primary-700",
  温暖: "bg-accent-100 text-accent-800",
  务实: "bg-background-200 text-foreground-700",
  文艺: "bg-secondary-100 text-secondary-800",
  活力: "bg-primary-100 text-primary-700",
};

export default function ChatRooms() {
  const [openRoom, setOpenRoom] = useState<string | null>("深夜书房");

  return (
    <section id="chatrooms" className="anchor-offset">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-3 md:max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">主题聊天室</span>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
            想聊就进，随时有人接着你的话
          </h2>
          <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
            聊天室按话题常驻开放，不需要预约也不用自我介绍。点开任意一个房间，可以看到里面正在聊些什么，
            觉得对味再发言。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {chatRooms.map((room) => {
            const isOpen = openRoom === room.name;
            const samples = roomSamples[room.name] ?? [];
            return (
              <article
                key={room.name}
                className={`flex flex-col gap-3 rounded-lg border bg-background-50 p-5 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className="ri-chat-smile-2-line text-lg" aria-hidden="true"></i>
                    </span>
                    <h3 className="font-heading text-base text-foreground-950 md:text-lg">{room.name}</h3>
                  </div>
                  <span className={`shrink-0 rounded-full px-2.5 py-1 text-[11px] font-medium ${moodClasses[room.mood] ?? "bg-background-200 text-foreground-700"}`}>
                    {room.mood}
                  </span>
                </div>
                <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-hashtag" aria-hidden="true"></i>
                    {room.topic}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-record-circle-line text-primary-600" aria-hidden="true"></i>
                    {room.online}
                  </span>
                </div>
                <p className="text-sm leading-relaxed text-foreground-600">{room.desc}</p>

                <button
                  type="button"
                  onClick={() => setOpenRoom(isOpen ? null : room.name)}
                  aria-expanded={isOpen}
                  className="mt-auto inline-flex items-center gap-1 self-start rounded-md border border-background-300 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer whitespace-nowrap"
                >
                  {isOpen ? "收起房间实况" : "看看在聊什么"}
                  <i className={isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} aria-hidden="true"></i>
                </button>

                {isOpen && (
                  <ul className="flex flex-col gap-2 rounded-md bg-background-100 p-3">
                    {samples.map((text) => (
                      <li key={text} className="rounded-md bg-background-50 px-3 py-2 text-xs leading-relaxed text-foreground-700">
                        {text}
                      </li>
                    ))}
                  </ul>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}